import React from 'react';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { useFormContext, useWatch } from 'react-hook-form';
import AlertStyledInput from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Alerts/components/ui/AlertStyledInput';
import PathControlledTextArea from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Alerts/components/ui/PathControlledTextArea';
import color from 'src/utils/colors';
import { CreateAlertConfigType } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Alerts/schema/AlertBuilderSchemaTypes';

const AlertSummaryTab: React.FC = () => {
  const { control, watch } = useFormContext<CreateAlertConfigType>();
  const formValues = useWatch({ control });

  const alertName = watch('alertName') || '';
  const alertDescription = watch('alertDescription') || '';

  // No need for manual syncing - react-hook-form handles this automatically
  // since the form fields are directly connected to the main form via useFormContext

  return (
    <Flex flexDirection="column" gap={24}>
      {/* Alert Name */}
      <Flex flexDirection="column">
        <Flex justifyContent="space-between" alignItems="center">
          <Text variant="h3" sx={{ fontWeight: 600, marginBottom: '8px' }}>
            Alert Name
          </Text>
          <Text variant="body3" sx={{ color: color.grey }}>
            {50 - alertName.length} characters remaining
          </Text>
        </Flex>
        <AlertStyledInput<CreateAlertConfigType>
          textSx={{ display: 'none' }}
          placeholder="Enter the alert name"
          name="alertName"
          characterLimit={50}
          defaultValue={formValues?.alertName}
          filterRegex={/[a-zA-Z0-9 ]/}
        />
      </Flex>

      {/* Alert Description */}
      <Flex flexDirection="column">
        <Flex justifyContent="space-between" alignItems="center" sx={{ marginBottom: '8px' }}>
          <Text variant="h3" sx={{ fontWeight: 600 }}>
            Alert Description
          </Text>
          <Text variant="body3" sx={{ color: color.grey }}>
            {100 - alertDescription.length} characters remaining
          </Text>
        </Flex>
        <PathControlledTextArea<CreateAlertConfigType>
          name="alertDescription"
          placeholder="Enter a description for your alert"
          rows={3}
          characterLimit={100}
        />
      </Flex>
    </Flex>
  );
};

export default AlertSummaryTab;
